import { render, staticRenderFns } from "./BidApply.vue?vue&type=template&id=5a015fba&scoped=true&"
import script from "./BidApply.vue?vue&type=script&lang=js&"
export * from "./BidApply.vue?vue&type=script&lang=js&"
import style0 from "./BidApply.vue?vue&type=style&index=0&id=5a015fba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a015fba",
  null
  
)

export default component.exports